import { render, staticRenderFns } from "./SkeletonIcon.vue?vue&type=template&id=1495f1a6&scoped=true"
import script from "./SkeletonIcon.vue?vue&type=script&lang=js"
export * from "./SkeletonIcon.vue?vue&type=script&lang=js"
import style0 from "./SkeletonIcon.vue?vue&type=style&index=0&id=1495f1a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1495f1a6",
  null
  
)

export default component.exports